import api from '../../api';

// initial state
const state = {
    onLoading: true,
    data: {}
};

// getters
const getters = {};

// actions
const actions = {
    // eslint-disable-next-line
    show({ commit }) {
        return api.internalSettingShow();
    },
    update({ commit }, entity) {
        return api.internalSettingUpdate(entity).then(res => {
            commit('setData', res.data);
            return res;
        });
    }
};

// mutations
const mutations = {
    setData(state, data) {
        state.data = data;
    },
    setOnLoading(state, loadingStatus) {
        state.onLoading = loadingStatus;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
